import { CssVarsProvider } from '@mui/joy/styles/CssVarsProvider';

export default CssVarsProvider;
